var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.is,{tag:"component",attrs:{"disabled":_vm.disabled,"readonly":_vm.readonly,"ean":_vm.ean,"product":_vm.product}})}
var staticRenderFns = []

export { render, staticRenderFns }